import {IconWrapper} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  "data-slot": "icon",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<mask id=\"i949918783__a\"><circle cx=\"256\" cy=\"256\" r=\"256\" fill=\"#fff\"></circle></mask><g mask=\"url(#i949918783__a)\"><path fill=\"#d80027\" d=\"m0 256 256.4-44.3L512 256v256H0z\"></path><path fill=\"#eee\" d=\"M0 0h512v256H0z\"></path></g>", 2)
  ])))
}
export default { render() { return h(IconWrapper, {icon: {render}, name: "polish"}) } }